<template>
  <div class="success-page-container">
    <!-- 顶部导航栏 -->
    <header class="navbar">
      <div class="navbar-content">
        <button class="back-btn" @click="goBack">
          <i class="fa fa-arrow-left"></i>
        </button>
        <h1 class="page-title">领取结果</h1>
        <div class="empty-space"></div>
      </div>
    </header>

    <!-- 主要内容区 -->
    <main class="main-content">
      <!-- 成功图标 -->
      <div class="success-icon-container">
        <div class="success-icon">
          <i class="fa fa-check"></i>
        </div>
      </div>

      <!-- 成功信息 -->
      <div class="success-message">
        <h2 class="success-title">领取成功！</h2>
        <p class="success-desc">您已成功领取，我们将<span class="highlight">尽快</span>安排工作人员上门为您激活</p>
      </div>

      <!-- 信息卡片 -->
      <div class="info-card">
        <div class="info-item">
          <span class="info-label">订单编号</span>
          <span class="info-value">{{ orderNumber }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">领取时间</span>
          <span class="info-value">{{ receiveTime }}</span>
        </div>
        <!-- <div class="info-item">
          <span class="info-label">预计上门时间</span>
          <span class="info-value">{{ estimatedTime }}</span>
        </div> -->
      </div>

      <!-- 后续步骤 -->
      <div class="steps-section">
        <h3 class="steps-title">后续步骤</h3>
        <ul class="steps-list">
          <li class="step-item">
            <div class="step-number">1</div>
            <div class="step-content">
              <p>保持手机畅通，等待工作人员联系</p>
            </div>
          </li>
          <li class="step-item">
            <div class="step-number">2</div>
            <div class="step-content">
              <p>准备好身份证，以便工作人员为您激活</p>
            </div>
          </li>
          <li class="step-item">
            <div class="step-number">3</div>
            <div class="step-content">
              <p>激活完成后即可正常使用流量服务</p>
            </div>
          </li>
        </ul>
      </div>

      <!-- 帮助按钮 -->
      <!-- <button class="help-btn" @click="showHelp">
        <i class="fa fa-question-circle"></i>
        有疑问？联系客服
      </button> -->
    </main>

    <!-- 底部操作区 -->
    <footer class="footer-actions">
      <button class="primary-btn" @click="goBack">返回领取页</button>
    </footer>

    <!-- 客服弹窗 (默认隐藏) -->
    <div class="modal" v-if="showModal">
      <div class="modal-content">
        <div class="modal-header">
          <h3>联系客服</h3>
          <button class="close-btn" @click="showModal = false">
            <i class="fa fa-times"></i>
          </button>
        </div>
        <div class="modal-body">
          <p class="contact-info">客服热线：400-123-4567</p>
          <p class="contact-info">工作时间：9:00-18:00（工作日）</p>
          <button class="call-btn" @click="makeCall">
            <i class="fa fa-phone"></i> 立即拨打
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 订单信息 - 实际项目中可从接口获取
      orderNumber: 'TK' + Math.floor(Math.random() * 100000000),
      receiveTime: this.formatDate(new Date()),
      estimatedTime: this.calculateEstimatedTime(),
      showModal: false
    };
  },
  methods: {
    // 返回上一页
    goBack() {
      this.$router.go(-1);
    },
    // 返回首页
    goHome() {
      this.$router.push('/');
    },
    // 显示帮助弹窗
    showHelp() {
      this.showModal = true;
    },
    // 拨打电话 
    makeCall() {
      window.location.href = 'tel:4001234567';
    },
    // 格式化日期
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}`;
    },
    // 计算预计上门时间（2个工作日内）
    calculateEstimatedTime() {
      const today = new Date();
      let daysToAdd = 3;
      let currentDate = new Date(today);
      
      while (daysToAdd > 0) {
        currentDate.setDate(currentDate.getDate() + 1);
        const dayOfWeek = currentDate.getDay();
        
        // 跳过周末（周六和周日）
        if (dayOfWeek !== 0 && dayOfWeek !== 6) {
          daysToAdd--;
        }
      }
      
      return this.formatDate(currentDate).split(' ')[0];
    }
  }
};
</script>

<style scoped>
/* 基础样式 */
.page-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: #f5f7fa;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}

/* 导航栏样式 */
.navbar {
  background-color: #ffffff;
  padding: 16px 15px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.navbar-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.back-btn {
  background: none;
  border: none;
  font-size: 20px;
  color: #333333;
  padding: 5px;
  cursor: pointer;
}

.page-title {
  font-size: 18px;
  font-weight: 600;
  color: #333333;
  margin: 0;
}

.empty-space {
  width: 24px; /* 与返回按钮宽度保持一致，使标题居中 */
}

/* 主要内容区样式 */
.main-content {
  flex: 1;
  padding: 30px 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* 成功图标样式 */
.success-icon-container {
  margin-bottom: 25px;
  animation: fadeIn 0.5s ease-out;
}

.success-icon {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background-color: #e6f7ee;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.2);
}

.success-icon i {
  font-size: 50px;
  color: #4caf50;
}

/* 成功信息样式 */
.success-message {
  text-align: center;
  margin-bottom: 30px;
  animation: slideUp 0.5s ease-out 0.2s forwards;
  opacity: 0;
  transform: translateY(10px);
}

.success-title {
  font-size: 24px;
  font-weight: 600;
  color: #333333;
  margin: 0 0 10px 0;
}

.success-desc {
  font-size: 16px;
  color: #666666;
  line-height: 1.5;
  margin: 0;
}

.highlight {
  color: #ff5722;
  font-weight: 500;
}

/* 信息卡片样式 */
.info-card {
  width: 100%;
  background-color: #ffffff;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  margin-bottom: 30px;
  animation: slideUp 0.5s ease-out 0.4s forwards;
  opacity: 0;
  transform: translateY(10px);
}

.info-item {
  display: flex;
  justify-content: space-between;
  padding: 12px 0;
  border-bottom: 1px solid #f5f5f5;
}

.info-item:last-child {
  border-bottom: none;
}

.info-label {
  font-size: 15px;
  color: #666666;
}

.info-value {
  font-size: 15px;
  color: #333333;
  font-weight: 500;
  text-align: right;
}

/* 后续步骤样式 */
.steps-section {
  width: 100%;
  margin-bottom: 40px;
  animation: slideUp 0.5s ease-out 0.6s forwards;
  opacity: 0;
  transform: translateY(10px);
}

.steps-title {
  font-size: 18px;
  font-weight: 600;
  color: #333333;
  margin: 0 0 15px 0;
}

.steps-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.step-item {
  display: flex;
  margin-bottom: 20px;
  position: relative;
}

.step-item:not(:last-child)::after {
  content: '';
  position: absolute;
  left: 14px;
  top: 30px;
  bottom: -20px;
  width: 2px;
  background-color: #e0e0e0;
}

.step-number {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: #e6f7ee;
  color: #4caf50;
  font-size: 16px;
  font-weight: 600;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 15px;
  flex-shrink: 0;
}

.step-content {
  flex: 1;
}

.step-content p {
  margin: 0;
  font-size: 15px;
  color: #666666;
  line-height: 1.5;
}

/* 帮助按钮样式 */
.help-btn {
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 25px;
  padding: 12px 20px;
  font-size: 16px;
  color: #333333;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s ease;
  animation: slideUp 0.5s ease-out 0.8s forwards;
  opacity: 0;
  transform: translateY(10px);
}

.help-btn i {
  margin-right: 8px;
  color: #4caf50;
}

.help-btn:hover {
  background-color: #f9f9f9;
  border-color: #d0d0d0;
}

/* 底部操作区样式 */
.footer-actions {
  padding: 15px;
  background-color: #ffffff;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.05);
}

.primary-btn {
  width: 100%;
  background-color: #4caf50;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  padding: 15px;
  font-size: 17px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.primary-btn:hover {
  background-color: #3d9140;
}

/* 弹窗样式 */
.modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  animation: fadeIn 0.3s ease-out;
}

.modal-content {
  background-color: #ffffff;
  border-radius: 12px;
  width: 90%;
  max-width: 350px;
  animation: scaleIn 0.3s ease-out;
}

.modal-header {
  padding: 18px 20px;
  border-bottom: 1px solid #f5f5f5;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #333333;
}

.close-btn {
  background: none;
  border: none;
  font-size: 20px;
  color: #999999;
  cursor: pointer;
}

.modal-body {
  padding: 20px;
}

.contact-info {
  margin: 0 0 15px 0;
  font-size: 16px;
  color: #333333;
  display: flex;
  align-items: center;
}

.contact-info:last-of-type {
  margin-bottom: 25px;
}

.contact-info:before {
  content: "•";
  color: #4caf50;
  font-weight: bold;
  margin-right: 10px;
}

.call-btn {
  width: 100%;
  background-color: #4caf50;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  padding: 12px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background-color 0.3s ease;
}

.call-btn i {
  margin-right: 8px;
}

.call-btn:hover {
  background-color: #3d9140;
}

/* 动画效果 */
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes scaleIn {
  from { transform: scale(0.9); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
}

/* 响应式调整 */
@media (min-width: 768px) {
  .main-content, .footer-actions {
    max-width: 500px;
    margin-left: auto;
    margin-right: auto;
  }
}
</style>
